"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _getProgressionDescriptionForObjective = require("./getProgressionDescriptionForObjective");

var _getOneDisplayValue = _interopRequireDefault(require("../display/getOneDisplayValue"));

var _getSplitActivityProgressionForObjectiveLiteral = require("./getSplitActivityProgressionForObjectiveLiteral");

var _getActivityProgressionForObjective = _interopRequireDefault(require("./getActivityProgressionForObjective"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getLiteralSplitProgression = function getLiteralSplitProgression(props) {
  var challenge = props.challenge,
      measurementSystem = props.measurementSystem,
      t = props.t,
      precision = props.precision,
      language = props.language,
      defaultLanguage = props.defaultLanguage;

  var _ref = challenge || {},
      _ref$conditions = _ref.conditions;

  _ref$conditions = _ref$conditions === void 0 ? {} : _ref$conditions;
  var _ref$conditions$combi = _ref$conditions.combinations,
      combinations = _ref$conditions$combi === void 0 ? [] : _ref$conditions$combi,
      userChallenge = _ref.userChallenge;

  var _ref2 = userChallenge || {},
      calculationState = _ref2.calculationState;

  var _ref3 = calculationState || {},
      _ref3$progression = _ref3.progression;

  _ref3$progression = _ref3$progression === void 0 ? {} : _ref3$progression;
  var _ref3$progression$obj = _ref3$progression.objectives,
      objectivesProgression = _ref3$progression$obj === void 0 ? [] : _ref3$progression$obj;
  return combinations.map(function (condition, conditionIndex) {
    var _objectivesProgressio, _objectivesProgressio2, _objectivesProgressio3;

    var getCompletedObjectives = function getCompletedObjectives(items) {
      return (items === null || items === void 0 ? void 0 : items.filter(function (item) {
        return item === null || item === void 0 ? void 0 : item.isFinished;
      }).length) || 0;
    };

    var repeat = condition.repeat;
    var repetitions = objectivesProgression === null || objectivesProgression === void 0 ? void 0 : (_objectivesProgressio = objectivesProgression[conditionIndex]) === null || _objectivesProgressio === void 0 ? void 0 : (_objectivesProgressio2 = _objectivesProgressio.frequencies) === null || _objectivesProgressio2 === void 0 ? void 0 : (_objectivesProgressio3 = _objectivesProgressio2[0]) === null || _objectivesProgressio3 === void 0 ? void 0 : _objectivesProgressio3.repetitions;
    var literalProgressionValue = repeat ? getCompletedObjectives(repetitions) : (0, _getSplitActivityProgressionForObjectiveLiteral.getSplitActivityProgressionValueForObjectiveLiteral)({
      objective: condition,
      splitActivity: repetitions === null || repetitions === void 0 ? void 0 : repetitions[0],
      measurementSystem: measurementSystem,
      t: t,
      precision: precision || 2
    });
    var progressionDescription = (0, _getProgressionDescriptionForObjective.getProgressionDescriptionForObjective)({
      objective: condition,
      t: t
    });
    var objectiveProgression = repeat ? {
      goal: repeat,
      value: literalProgressionValue,
      percentageCompleted: Math.floor(literalProgressionValue / repeat * 100)
    } : (0, _getActivityProgressionForObjective["default"])({
      objective: condition,
      activity: repetitions === null || repetitions === void 0 ? void 0 : repetitions[0]
    });
    return _objectSpread({
      label: (0, _getOneDisplayValue["default"])({
        key: 'description',
        display: condition.display || {},
        language: language,
        defaultLanguage: defaultLanguage
      }) || progressionDescription,
      isRepeat: !!condition.repeat,
      progression: {
        percentageCompleted: objectiveProgression.percentageCompleted,
        value: objectiveProgression.value,
        valueLiteral: literalProgressionValue,
        goal: objectiveProgression.goal
      },
      activityTypes: condition.types || []
    }, (condition === null || condition === void 0 ? void 0 : condition.minDuration) ? {
      minDuration: condition === null || condition === void 0 ? void 0 : condition.minDuration
    } : {});
  });
};

var _default = getLiteralSplitProgression;
exports["default"] = _default;
//# sourceMappingURL=getLiteralSplitProgression.js.map